export const environment = {
	production: true,
	url :'https://backendtransport.iogreen.in',
	voucher_email_1 : 'mantubhutada@gmail.com',
  	voucher_email_2 : 'mehboob95786@gmail.com'
};



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/environments/environment.ts